import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"

export const handleCreateRating = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/member/webinar/rating/create`
      },
      thunkAPI
    )
  }
)

export const handleRetrieveSingleWebinarRating = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/member/webinar/rating/get/${id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)